<section>
  <div class="container">
    <div class="inner-banner boarding-banner d-flex align-items-center bg-primary my-5">
      <div class="text-white title-box">
        <h1 class="p-0">Board at Safari Veterinary Care Centers</h1>
        <p class="m-0">
          Safari staff are trained to lovingly care for a wide range of pets and
          give them the best boarding experience possible.
        </p>
      </div>
      <img [src]="'assets/images/boarding-services/banner-img.png'" alt="" class="bg-img" />
    </div>
  </div>
</section>
<section>
  <div class="container">
    <p class="mb-2">
      Safari Veterinary Care Centers is happy to offer boarding services to our clients for their dogs, cats, and many
      other
      species. Because we are primarily a veterinary hospital, we have vulnerable and medically compromised pets in our
      facility as well, whose safety must be ensured. One of the ways we do this is to require current vaccinations for
      boarding which protects not only our hospital patients, but also your pet while here with us.
    </p>
    <p>
      Another way is that we must carefully screen dogs for any signs of aggression toward other animals. If you are
      unsure
      if your dog can be boarded, our boarding staff are happy to schedule a boarding assessment with you and your pet.
    </p>
  </div>
</section>
<section class="boarding-exp-sec">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="outer-box p-md-5 p-4 bg-light">
          <div class="row">
            <div class="col-lg-6">
              <div class="me-5 text-center text-lg-start">
                <h3 class="text-primary">
                  Give Your Pet The Best Boarding Experience
                  <span class="text-secondary">Book Now!!</span>
                </h3>
                <p>
                  Please select your check-in and Check-out Dates and the number
                  of pets you would like to board, when you click check
                  availability you will be able to select the kennel type for
                  your booking.
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-box rounded-4 bg-white p-4">
                <form action="" class="d-flex flex-column align-items-center h-100">
                  <p-calendar class="form-input form-input-with-box iconic-feild order-date-picker w-100 mb-3"
                    [appendTo]="'body'" placeholder="Select check-in date" [(ngModel)]="inwardDate"
                    [ngModelOptions]="{ standalone: true }" [minDate]="minInWardDate" [maxDate]="maxDate"
                    [dateFormat]="pCalendarDateFormat" (onSelect)="selectInwardDate()" [readonlyInput]="true"
                    hideOnDateTimeSelect="true" [showIcon]="true" styleClass="p-calendar">
                    <ng-template pTemplate="date" let-date>
                      <span [ngStyle]="{
                          backgroundColor: getSelectedDays(date)
                            ? '#6bb9ff'
                            : 'inherit',
                          color: getSelectedDays(date) ? '#ffffff' : 'inherit'
                        }" class="selected-inward">{{ date.day }}</span>
                    </ng-template>
                  </p-calendar>

                  <p-calendar class="form-input form-input-with-box iconic-feild order-date-picker w-100 mb-3"
                    [appendTo]="'body'" #checkout placeholder="Select check-out date" [(ngModel)]="outwardDate"
                    [ngModelOptions]="{ standalone: true }" [minDate]="inwardDate" [dateFormat]="pCalendarDateFormat"
                    (onSelect)="selectOutwardDate()" [readonlyInput]="true" [showIcon]="true" styleClass="p-calendar">
                    <ng-template pTemplate="date" let-date>
                      <span [ngStyle]="{
                          backgroundColor: getSelectedDays(date)
                            ? '#6bb9ff'
                            : 'inherit',
                          color: getSelectedDays(date) ? '#ffffff' : 'inherit'
                        }" class="selected-outward">{{ date.day }}</span>
                    </ng-template>
                  </p-calendar>

                  @if (cageTypeGrid.length) {
                  <ng-select class="form-control input-select new-pet-modal-grooming  mb-3"
                    [placeholder]="'Number of Pets to Book'" dropdownPosition="bottom" [items]="maximumnumberOfPets"
                    [searchable]="false" [(ngModel)]="selectedPetNumber" [ngModelOptions]="{ standalone: true }">
                  </ng-select>
                  }

                  <button class="btn btn-success w-100 mt-auto" (click)="onFilterApply()" [ladda]="isFilter">
                    Check Availability
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="mt-5 cage-listing">
  <div class="container">
    @if(!availableCagesForOutpost.length&& !notAvailableCagesForOutpost.length){
    <div class="row">
      <div class="d-flex justify-content-center">
        <div class="text-center">
          <img class="opps-img mb-4 img-fluid" src="{{ defaultImagePath + 'boarding-services/opps-img.png' }}"
            alt="opps-image" />
          <div class="bottom-link text-start">
            Oops, seems all cages are booked. Please
            <a (click)="boardingRequestModal(bookingRequestModal)"><u class="fw-bold cursor-pointer">click
                here</u></a>
            to submit the request and one of our representative<br />
            will be with you soon.
          </div>
        </div>
      </div>
    </div>
    }

    <div class="row">
      @if(availableCagesForOutpost?.length){
      <div class="row">
        <div class="col-12 text-center mb-4">
          <h3 class="text-info">
            {{ currentPet?.name | titlecase }} Boarding Options
          </h3>
          <h6 class="text-black my-3">Please select from our League City or Pearland locations below.</h6>
          <p>
            After you have selected check-in and check-out dates you can select
            a kennel type to get an estimate of the cost and check availability
          </p>
        </div>
      </div>
      <!-- card block - -->

      <app-block-spinner [name]="'boarding_detail'" [isSpinnerShow]="spinnerVariable"></app-block-spinner>
      <h4 class="text-secondary">{{selectedOutPost?.title}}</h4>
      @for (cage of availableCagesForOutpost; track $index) {
      <div class="col-xl-4 col-md-6 col-12 mb-4">
        <div class="cage-box d-flex flex-column">
          <div class="cursor-pointer">
            <figure class="card-figure">
              <img class="rounded-3 img-fluid"
                [src]="filePath +'cage/' +cage?.id + '/cover_image/' +cage?.default_cover_image" alt=""
                onerror="this.src='assets/images/default_cage.png'" (click)="redirectCageDetails(cage)" />
            </figure>
          </div>
          <!-- <img src="../../../../../assets/images/home/pet-plan.png" alt="" class="rounded-3 img-fluid" /> -->

          <h6 class="card-title my-3">
            <a href="javascript:void(0)" (click)="redirectCageDetails(cage)">{{
              cage?.title
              }}</a>
          </h6>

          @if(cage?.review?.total_review > 0){
          <p>
            <app-star-rating [maxScore]="5" [score]="cage?.review?.ratting" [forDisplay]="true">
            </app-star-rating>&nbsp;({{ cage?.review?.total_review }})
          </p>
          }
          <div class="card-price">
            <span class="text-info h6"> {{ cage?.amount | currency }} </span>/day
          </div>
          <div class="mt-auto">
            <hr />
            <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
              <div class="size-area mb-3 mb-lg-0">
                Size: {{ cage?.width }} x {{ cage?.height }} x
                {{ cage?.length }} {{ cage?.unit }}
              </div>
              <div class="card-btn" [ngbTooltip]="
                  !isDateSet
                    ? 'Please select Check-In and Check-Out date and click on Check Availability for book this cage'
                    : ''
                ">
                <button class="btn btn-success cursor-pointer" [ngClass]="{ disabled: !isDateSet }"
                  (click)="isDateSet ? bookCage(cage) : ''">
                  <span>Book Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      } }
    </div>

    <div class="row">
      @if(notAvailableCagesForOutpost?.length){
      <hr class="mt-5" />

      <div class="row">
        <div class="col-12 text-center mb-4">
          <h6 class="text-black my-3">The following kennels are available at our {{anotherOutpost?.title}} facility.
          </h6>
        </div>
      </div>
      <!-- card block - -->
      <h4 class="text-secondary">{{anotherOutpost?.title}}</h4>
      @for (cage of notAvailableCagesForOutpost; track $index) {

      <div class="col-xl-4 col-md-6 col-12 mb-4">
        <div class="cage-box d-flex flex-column">
          <figure class="card-figure cursor-pointer">
            <img [src]="filePath +'cage/' +cage.id +'/cover_image/' +cage?.default_cover_image" alt=""
              (click)="redirectCageDetails(cage)" class="rounded-3 img-fluid"
              onerror="this.src='assets/images/default_cage.png'" />
          </figure>
          <!-- <img src="../../../../../assets/images/home/pet-plan.png" alt="" class="rounded-3 img-fluid" /> -->

          @if(!cage?.is_available_for_outpost){
          <div class="bottom-link">
            <a href="javascript:void(0)" (click)="onSelect(cage.id)">
              <u class="fw-bold">Click Here</u>
            </a>
            and change Center to continue with this Cage.
          </div>
          }

          <h6 class="card-title my-3">
            <a href="javascript:void(0)" [ngClass]="{
                disabled: !cage?.is_available_for_outpost
              }" (click)="redirectCageDetails(cage)">{{ cage?.title }}</a>
          </h6>

          @if(cage?.review?.total_review > 0){
          <p>
            <app-star-rating [maxScore]="5" [score]="cage?.review?.ratting" [forDisplay]="true">
            </app-star-rating>&nbsp;({{ cage?.review?.total_review }})
          </p>
          }
          <div class="card-price">
            <span class="text-info h6"> {{ cage?.amount | currency }} </span>/day
          </div>
          <div class="mt-auto">
            <hr />
            <div class="d-flex justify-content-between align-items-center flex-column flex-lg-row">
              <div class="size-area mb-3 mb-lg-0">
                Size: {{ cage?.width }} x {{ cage?.height }} x
                {{ cage?.length }} {{ cage?.unit }}
              </div>
              <div class="card-btn" [ngbTooltip]="
                  !isDateSet
                    ? 'Please select Check-In and Check-Out date and click on Check Availability for book this cage'
                    : ''
                ">
                <button class="btn btn-success cursor-pointer" [ngClass]="{
                    disabled: !isDateSet || !cage?.is_available_for_outpost
                  }" (click)="
                    isDateSet || cage?.is_available_for_outpost
                      ? bookCage(cage)
                      : ''
                  ">
                  <span>Book Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      } }
    </div>
  </div>
</section>
<section class="contact-form">
  <img [src]="'assets/images/home/form-bg-dog.png'" alt="" class="position-absolute start-0 end-0 mx-auto bg-dog mt-5">
  <div class="container">
    <app-contact-us></app-contact-us>
  </div>
</section>


<!-- Boarding request modal-->

<ng-template #bookingRequestModal let-modal>
  <div class="modal-header">
    <h5 class="text-info" id="exampleModalLongTitle">Boarding Request</h5>
    <button type="button" class="close btn-close" data-dismiss="modal" aria-label="Close"
      (click)="closeModalContent()"></button>
  </div>
  <div class="modal-body">
    <div class="form-inner">
      <form [formGroup]="boardingRequestFrom" id="boarding-request-from">
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="label-moves-up">
              <input type="text" trim="blur" id="name" name="name" class="form-control" placeholder="Name"
                formControlName="name" />
            </div>
            @if ((name?.touched || name?.dirty || submitted) && !name?.valid && !name?.pending) {
            @if (name?.errors?.required) {
            <span class="text-danger error">Name is required</span>
            }

            }
          </div>
          <div class="col-md-6 mb-4">
            <div class="label-moves-up">
              <input type="text" trim="blur" id="email" name="email" class="form-control" placeholder="Email"
                formControlName="email" />
            </div>
            @if ((email?.touched || email?.dirty || submitted) &&!email?.valid &&!email?.pending) {
            <span class="text-danger error">
              @if (email?.errors.required) {
              Email is required
              }
              @if (email?.errors.pattern) {
              Please enter valid email address
              }
            </span>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="label-moves-up">
              <input type="text" trim="blur" id="phone_number" name="phone_number" class="form-control"
                placeholder="Phone Number" formControlName="phone_number" />
            </div>
            @if ((phone_number?.touched ||
            phone_number?.dirty ||
            submitted) &&
            !phone_number?.valid &&
            !phone_number?.pending) {
            <span class="text-danger error">
              @if (phone_number?.errors.required) {Phone number is required}
              @if (phone_number?.errors.pattern) {Please enter numerals only (no-dashes)}
              @if (phone_number?.errors.maxlength) {Phone number not allow more than 10 digits}
            </span>
            }
          </div>
          <div class="col-md-6 mb-4">
            <div class="label-moves-up">
              <select class="form-select form-control" id="no_pets" name="no_pets" [formControl]="no_pets">
                <option value="">Number of pets needs to be booked</option>
                @for (number of numberOfPets; track $index) {
                <option value="{{ number }}">
                  {{ number }}
                </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="label-moves-up">
              <textarea id="notes" name="notes" class="form-control" placeholder="Notes" formControlName="notes"
                rows="2"></textarea>
            </div>
            @if ((notes?.touched || notes?.dirty || submitted) &&!notes?.valid &&!notes?.pending) {
            @if (notes?.errors.required) {
            <span class="text-danger error">Notes is required</span>
            }
            }
          </div>
        </div>
      </form>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" [ladda]="requestSentLadda" (click)="saveRequest()">
      <span>Send Request</span>
    </button>
  </div>
</ng-template>